import { useState, createContext } from "react";

import $ from "jquery";
import axios from "axios";

export const MainContext = createContext({
  busLinesData: [],
  busLineDataIsShow: false,

  mainContent: [],
  showMainPanel: false,
  showLeftPanel: false,
  showRightPanelMd: false,
  showFirstCat: false,

  setBusLinesData: () => {},
  toggleBusLineDataShow: () => {},

  showMainContent: () => {},
  toggleShowMainPanel: () => {},
  toggleShowLeftPanel: () => {},
  toggleShowRightPanelMd: () => {},
  toggleShowFirstCat: () => {},
});

const MainContextProvider = (props) => {
  const [busLinesData, SetBusLinesData] = useState();
  const [busLineDataIsShow, SetBusLineDataIsShow] = useState(false);

  const [mainContent, setMainPanelContent] = useState();

  const [showMainPanel, setShowMainPanel] = useState(false);
  const [showLeftPanel, setShowLeftPanel] = useState(false);
  const [showRightPanelMd, setShowRightPanelMd] = useState(false);
  const [showFirstCat, setShowFirstCat] = useState(false);

  const setBusLinesData = (content) => {
    SetBusLinesData(content);
  };
  const toggleBusLineDataShow = (state) => {
    SetBusLineDataIsShow(state);
  };

  const showMainContent = (content) => {
    setMainPanelContent(content);
  };

  const toggleShowMainPanel = (state) => {
    setShowMainPanel(state);
  };

  const toggleShowLeftPanel = (state) => {
    setShowLeftPanel(state);
  };
  const toggleShowRightPanelMd = (state) => {
    setShowRightPanelMd(state);
  };
  const toggleShowFirstCat = (state) => {
    setShowFirstCat(state);
  };

  return (
    <MainContext.Provider
      value={{
        busLinesData,
        busLineDataIsShow,
        mainContent,
        showMainPanel,
        showLeftPanel,
        showRightPanelMd,
        showFirstCat,
        setBusLinesData,
        toggleBusLineDataShow,

        showMainContent,
        toggleShowMainPanel,
        toggleShowLeftPanel,
        toggleShowRightPanelMd,
        toggleShowFirstCat,
      }}
    >
      {props.children}
    </MainContext.Provider>
  );
};

export default MainContextProvider;
